import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "phone-step form-screen" }
const _hoisted_2 = { class: "form-screen__body" }
const _hoisted_3 = { class: "h2 color-text-primary phone-step__title" }
const _hoisted_4 = {
  key: 0,
  class: "color-error hint"
}
const _hoisted_5 = {
  key: 1,
  class: "color-grey-blue caption-medium hint"
}
const _hoisted_6 = { class: "form-screen__footer" }

import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import BaseInput from "@/components/base/BaseInput.vue";
import { getPhoneNumber } from "@/utils/common";
import BaseButton from "@/components/base/BaseButton.vue";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PhoneStep',
  props: {
  isWrongPhone: Boolean,
  isLoadingBtn: Boolean,
},
  emits: ["submit", "back"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const { t } = useI18n();

const props = __props;

const phone = ref("");
const isValid = ref(false);
const showError = ref(false);
const errorPhone = ref(false);

const handleValidation = (validationResult: { isValidPhone: boolean }) => {
  isValid.value = validationResult.isValidPhone;
};

const handleSubmit = () => {
  if (!isValid.value) return;
  emit("submit", getPhoneNumber(phone.value));
  errorPhone.value = props.isWrongPhone;
};

const handleChange = () => {
  if (phone.value.length < 18) {
    errorPhone.value = false;
  }
};

watch(
  () => props.isWrongPhone,
  (val) => {
    if (phone.value.length === 18 && props.isWrongPhone) {
      errorPhone.value = true;
    }

    showError.value = val;

    if (showError.value) {
      isValid.value = false;
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BaseFigureForIcon, {
        size: "medium",
        color: "grey-secondary",
        icon: "arrow",
        position: "left",
        "is-button": "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
      }),
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(t)("auth.phone.title")), 1),
      _createVNode(BaseInput, {
        modelValue: phone.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((phone).value = $event)),
        type: "phone",
        class: _normalizeClass(["caption-medium color-text-primary phone-step__input", { error: errorPhone.value && !__props.isLoadingBtn }]),
        "max-length": 12,
        onValidation: handleValidation,
        onChange: handleChange
      }, null, 8, ["modelValue", "class"]),
      (showError.value && !__props.isLoadingBtn)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(t)("auth.phone.notFound")), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(t)("auth.phone.hint")), 1))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(BaseButton, {
        title: _unref(t)('auth.phone.continue'),
        size: "large",
        disabled: !isValid.value || __props.isLoadingBtn,
        color: "primary",
        onClick: handleSubmit
      }, null, 8, ["title", "disabled"])
    ])
  ]))
}
}

})